module.exports = __webpack_public_path__ + "static/Logo_UERJ-7ef1c1145624acbb72e281255420bdfb.png";